import { useParams } from 'react-router-dom';

import { AppStartupScreenSettingsPage } from '~/components/pages/AppStartupScreenSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppStartupScreenSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppStartupScreenSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
